import { useCallback, useEffect, useState } from "react";

export default function useRecoveryCooldown() {
  const [deadline, setDeadline] = useState(0);
  const [clock, setClock] = useState(Date.now);
  useEffect(() => {
    if (!deadline) return undefined;
    const timer = setInterval(() => {
      const current = Date.now();
      setClock(current);
      if (current >= deadline) setDeadline(0);
    }, 1000);
    return () => clearInterval(timer);
  }, [deadline]);
  const restart = useCallback((seconds) => {
    const current = Date.now();
    setClock(current);
    setDeadline(seconds > 0 ? current + Math.min(900, seconds) * 1000 : 0);
  }, []);
  return [Math.max(0, Math.ceil((deadline - clock) / 1000)), restart];
}
